import { UserRole } from "../types/user";
import useAccessTokenPayload from "./useAccessTokenPayload";

const useCanModifyDocs = () => {
  const { roles } = useAccessTokenPayload()!;
  return roles.includes(UserRole.SuperAdmin) || roles.includes(UserRole.Admin);
};

export default useCanModifyDocs;
